

import { apiN8N } from "../services/Api";

export function useN8N() {
  //const baseUrl = "webhook-test/f4fa48ba-fc15-4a4e-af26-111c5bcb2d4e";
  const baseUrlProd = "webhook/f4fa48ba-fc15-4a4e-af26-111c5bcb2d4e";
  const postExcelTransactionN8N = (data: any) => {
    return apiN8N.post(`${baseUrlProd}`, data);
  }

  return {
    postExcelTransactionN8N,
  };
}
